export const isMemberUpdateAuthorizationsResponse = (value) => Boolean(value &&
    typeof value === 'object' &&
    'linkedUserId' in value &&
    Array.isArray(value.authorizations) &&
    value.authorizations.every((item) => typeof item.id === 'string' &&
        typeof item.version === 'number' &&
        Array.isArray(item.scopes)));
export const isMemberUpdateCapabilitiesResponse = (value) => Boolean(value &&
    typeof value === 'object' &&
    Array.isArray(value.capabilities));
